export default {
	nav: {
		product: 'Produkt',
		about: 'O nás',
		partners: 'Partneři',
		offerto: 'Chci Offerto!'
	},
	main: {
		header: 'Spolehlivá data v reálném čase',
		button: 'Začněte',
	},
	about: {
		header: 'Data, kterým můžete věřit',
		firstSectionHeader: '1. Databáze produktů',
		firstSectionText: 'Naše jedinečné řešení konfigurace produktů Vám umožní že už nikdy nebudete muset žádné informace hledat nebo počítat ručně. S offertem si můžete nastavit všechny možné varianty Vašeho produktu s jeho ptřebnými doplňky které tak naceníte v nabídce jedním kliknutím!',
		secondSectionHeader: '2. Tvorba cenových nabídek',
		secondSectionText: 'Díky Offertu získáte automatizovaný nástroj pro tvorbu cenových nabídek jak pro Vaše obchodníky, tak i zákazníky.',
		thirdSectionHeader: '3. Tvorba objednávek',
		thirdSectionText: 'Objednávejte jedním kliknutím s přímým napojením do ERP systému jako je Pohoda, Helios, SAP a další.',
		fourthSectionHeader: '4. Databáze firem',
		fourthSectionText: 'Mějte všechny své klienty, nabídky i objednávky hezky uspořádané k firmě se kterou obchodujete.',
		fifthSectionHeader: '5. Systémové notifikace',
		fifthSectionText: 'Offerto vám vždy dá vědět každou důležitou informaci do systému i do Vašeho emailu. Už nikdy vám neuteče nic důlžitého!',
		sixthSectionHeader: '6. Reporty',
		sixthSectionText: 'Máme přehledné reporty díky kterým můžete mít dokonalý přehled o souhrnu všech dat které potřebujete. A ano! Děláme i reporty na míru.',
	},
	solution: {
		header: 'Rychlejší řešení obchodních případů',
		text: 'Offerto Vám i Vašim zákazníkům pomůže rychle vyřešit cenu Vašeho zboží, dostupnost a objednání s přímým napojením do ERP systému. Vyzkoušejte, jak jednoduché to je!',
		button: 'Chci vyzkoušet Offerto'
	},
	story: {
		header: 'O nás',
		sections: {
			story: {
				header: 'Příběh',
				text: 'Offerto vzniklo z nápadu dvou našich obchodníků. Naším cílem je, firmám pomoci zrychlit a zjednodušit jejich obchodní procesy s různými montážními trasami jakéhokoli druhu. Po dlouhé práci našich zkušených programátorů vznikl software který dokáže nejen to, ale i mnohem více a víme, že příběh Offerta ještě nekončí a mnoho dalších skvělých věcí se pro naše zákazníky chystá.'
			},
			vision: {
				header: 'Vize',
				text: 'Naší vizí je plně automatizovat a zrychli obchodní procesy. S námi už Vaši obchodníci nebudou muset používat excel s kalkulačkou v ruce. Našim cílem je aby se obchodníci mohli věnovat důležitějším věcem než je hledání cen v kalatogu. Při spolupráci s našimi klienty hledíme především na funkčnost našeho řešení ale také na jeho vizuální stránku aby tvořilo příjemné prostředí do kterého se Vy i Vaši klienti budou rádi vracet.'
			},
			technology: {
				header: 'Technologie',
				text: 'Offerto! Inovativní software, který se plně přizpůsobí Vaší společnosti a zajistí rychlejší komunikaci a výměnu dat mezi kolegy a zákazníky.'
			}
		}
	},
	reference: {
		header: 'Produced by',
		companyName: 'Innovasoft'
	},
	contact: {
		header: 'Máte zájem o offerto?',
		subheader: 'Objednejte si jej a náš obchodní specialista se s Vámi spojí',
		form: {
			name: 'Jméno',
			lastName: 'Příjmení',
			email: 'Email',
			phone: 'Telefon',
			company: 'Společnost',
			position: 'Pozice',
			button: 'Odeslat',
			acceptConditions: 'Souhlasím s ',
			conditions: 'obchodními podmínkami',
		},
		messages: {
			formError: 'Nepodařilo se odeslat email pro kontaktní osobu. Prosím kontaktujte nás na emailu info@innovasoft.cz děkujeme.',
			formSuccess: 'Odeslání formuláře bylo úspěšné',
			requiredFieldsAlert: 'Prosím vyplňtě všechna povinná pole!',
			validEmailAlert: 'Prosím vyplňtě platný email!',
			recaptchaAlert: 'Prosím ověřtě že nejste robot!'
		}
	},
	packages: [
		{
			name: 'start',
			header: 'Start',
			price: '990 Kč / měsíc',
			desc1: 'Až 3 aktivní obchodníci',
			desc2: 'Neomezený počet klientů',
			desc3: 'Reporty',
			button: 'Chci balíček start!',
			icon: 'iconfas-startFlag',
			bgColor: '#b5bdff',
			color: '#3C53F4',
		},
		{
			name: 'standard',
			header: 'Standard',
			price: '1 390 Kč / měsíc',
			desc1: 'Až 8 aktivní obchodníků',
			desc2: 'Neomezený počet klientů',
			desc3: 'Reporty',
			button: 'Chci balíček standard!',
			icon: 'iconfas-userBook',
			bgColor: '#beaa8a',
			color: '#c07524',
		},
		{
			name: 'premium',
			header: 'Premium',
			price: '1 690 Kč / měsíc',
			desc1: 'Až 15 aktivní obchodníků',
			desc2: 'Neomezený počet klientů',
			desc3: 'Reporty',
			button: 'Chci balíček premium!',
			icon: 'iconfas-award',
			bgColor: '#d5d5d7',
			color: '#888888',
		},
		{
			name: 'unlimited',
			header: 'Unlimited',
			price: 'Individuální',
			desc1: 'Neomezený počet obchodníků',
			desc2: 'Neomezený počet klientů',
			desc3: 'Reporty',
			button: 'Chci balíček unlimited!',
			icon: 'iconfas-trophy',
			bgColor: '#FFDEA0',
			color: '#ffa600',
		},
	],
	footer: {
		email: 'E-mail:',
		phone: 'Telefon:',
		copyright: 'Innovasoft',
		social: 'Sociální sítě'
	}
};
